<div mat-dialog-title>
  <a mat-icon-button (click)="onClose()" >
    <!-- <mat-icon class="material-icons">keyboard_backspace</mat-icon> -->
    <!-- <i class='fas fa-arrow-left fa-lg'></i> -->
    
    <img [src]=backimg class="iconimage"/>

  </a>
  <label class="title"> New Job</label>
</div>

<div mat-dialog-content>
  <form class="container" [formGroup]="form" >
    <mat-form-field >
      <input matInput type="text" formControlName="wwid" placeholder="WWID" [(ngModel)]="wwid" readonly />
    </mat-form-field>

    <mat-form-field >
      <input matInput type="text" formControlName="employeeName" placeholder="EmployeeName" [(ngModel)]="employeeName" readonly/>
    </mat-form-field>
    <mat-form-field>
      <mat-select name="OptionsString"  placeholder="Category" [(value)]="selectedCategory" (valueChange)="itemSelect($event)">
        <mat-option [value]="'PM'">PM</mat-option>
        <mat-option [value]="'OOS'">OOS</mat-option>
        <mat-option [value]="'TYRE'">TYRE</mat-option>
        <mat-option [value]="'FERRY'">FERRY</mat-option>
        <mat-option [value]="'BREAKDOWN'">BREAKDOWN</mat-option>
        <mat-option [value]="'SUBLET'">SUB-LET</mat-option>                      
        <mat-option [value]="'HANBACK/BUYBACK'">HANDBACK/BUYBACK</mat-option> 
        <mat-option [value]="'RECALL/WARRANTY'">RECALL/WARRANTY</mat-option>   
        <!-- <mat-option [value]="'Recall/Warranty'">Recall/Warranty</mat-option>           -->
        <mat-option [value]="'OTHER'">OTHER</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field *ngIf="selectedCategory === 'PM'">
      <mat-select 
        name="OptionsString"  
        placeholder="Service Type"
        [(value)]="defaultServiceRange"
        (valueChange)="rangeSelect($event)">

        <mat-option *ngFor="let range of PMSegmentList" [value]="range">
          {{ range }}
        </mat-option>
      
      </mat-select>
    </mat-form-field>

    <mat-form-field>
      <input
        matInput
        type="text"
        formControlName="MVA"
        placeholder="MVA"
        (change)="fetchData()"
        [(ngModel)]="MVA"
        required
      />
      <!-- <mat-icon matSuffix  (click)="QRScanner()">qr_code_2</mat-icon> -->

      <i class='fas fa-qrcode' matSuffix></i>    </mat-form-field>

    <mat-form-field >
      <input
        matInput
        type="text"
        formControlName="REGO"
        placeholder="REGO"
        (change)="fetchDataUsingRego()"
        [(ngModel)]="REGO"
        required
      />
    </mat-form-field>

    <mat-form-field >
      <input
        matInput
        type="text"
        formControlName="model"
        placeholder="MODEL Description"
        [(ngModel)]="model"
        required
        
      />
    </mat-form-field>
    <mat-form-field *ngIf="selectedCategory != 'PM'">
      <input
        matInput
        type="text"
        formControlName="km"
        placeholder="KMS"
        [(ngModel)]="km"
        
        required
        
      />
    </mat-form-field>
    <mat-form-field *ngIf="selectedCategory === 'PM'">
      <mat-label>KMS</mat-label>
      <input
        matInput
        type="text"
        formControlName="km"
        [placeholder]="km"
        
        (blur)="updateServiceRangeOnKmBlur()"
        required
        
      />
      <mat-hint align="start">
        Confirm (type) odometer (km)<br />
        after checking the vehicle.
      </mat-hint>
    </mat-form-field>
  </form>
</div>
<footer color="primary" class="sticky">
  <mat-dialog-actions *ngIf="d">
    <!-- Added method startTimer to show time in console  -->
    <button
      mat-button
      (click)="onClose()"
      (click)="startTimer()"
      type="submit"
      [disabled]="form.invalid || !isKmsInRange"
    >
      <span class="logo">
        <h3>Continue</h3>
      </span>
    </button>
  </mat-dialog-actions>
  <mat-dialog-actions *ngIf="!d">
    <!-- Added method startTimer to show time in console  -->
    <button
      mat-button
      (click)="onClose()"
      (click)="startTimer()"
      type="submit"
      [disabled]="d || !isKmsInRange"
    >
      <span class="logo">
        <h3>Continue</h3>
      </span>
    </button>
  </mat-dialog-actions>
</footer>
